export function tableReportProjects(HelperTable) {

    const selectorTable = '#table-report-projects';
    const elTable = $(selectorTable)

    if (!elTable.length) {
        return;
    }

    let columns = [];

    columns = [
        {
            label: ESR.lang.id,
            data: 'post_id',
            className: 'id min-tablet-p',
            visible: true
        },
        {
             label: ESR.lang.project_title,
            data: 'post_title',
            className: 'post_title min-tablet-p',
            visible: true
        },
        {
            label: ESR.lang.total_a,
            data: 'total_a',
            className: 'total min-tablet-p',
            visible: true
        },
        // {
        //     label: ESR.lang.total_c,
        //     data: 'total_c',
        //     className: 'total min-tablet-p',
        //     visible: true
        // }
    ];


    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        order: [
            [2, 'dsc']
        ],
        // stateSave: true,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            // topStart: toolbar,
            topStart: {
                buttons: [
                    // 'pageLength',
                    {
                        extend: 'colvis',
                        className: 'btn btn-sm btn-neutral',
                    },
                    {
                        extend: 'collection',
                        text: ESR.lang.export,
                        className: 'btn btn-sm btn-neutral btn-export',
                        buttons: [
                            {
                                extend: 'excelHtml5',
                                exportOptions: {
                                    modifier: {selected: null}, // all pages
                                    columns: ':visible'
                                }
                            },
                            {
                                extend: 'pdf',
                                text: 'PDF',
                                exportOptions: {
                                    modifier: {selected: null}, // all pages
                                    columns: ':visible'
                                }
                            },
                            {
                                extend: 'print',
                                text: ESR.lang.print,
                                exportOptions: {
                                    modifier: {selected: null}, // all pages
                                    columns: ':visible'
                                }
                            }
                        ]
                    },

                ]
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
            buttons: {
                // colvis: 'Coloane',
            }
        },
        displayLength: 100,
    });

}